
import Vue from 'vue';
import { Wrapper, SelectCustom } from './styles';

export default Vue.extend({
  name: 'Select',
  components: {
    Wrapper,
    SelectCustom,
  },
  props: {
    label: {
      type: String,
      default: '',
    },
    options: {
      type: String,
      default: '',
    },
    default: {
      type: String,
      required: false,
      default: null,
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0,
    },
    messageEmpty: {
      type: String,
      default: '',
    },
    heightItems: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // eslint-disable-next-line no-nested-ternary
      selected: this.default ? this.default : this.options.length > 0 ? this.options[0] : null,
      open: false,
    };
  },
  methods: {
    onBlur(evt: Event) {
      if (!this.disabled) {
        this.$emit('blur', evt);
      }
    },
  },
});
